export const monitoring_plans_module = "Monitoring Plans";
export const qa_Certifications_Test_Summary_Module =
  "QA Certifications Test Data";
export const qa_Certifications_Event_Module =
  "QA Cert Event Data & Test Extension Exemption Data";
export const export_Module = "Export & Report";
export const emissions_module = "Emissions";
export const error_supression_module = "Error Suppression";
export const submissionAccessTitle = "Maintain EM Submission Access";
export const qaCertDataMaintenanceTitle = "QA/Cert Data Maintenance";
export const configurationManagementTitle = "Configuration Management";
export const submissionReportTitle = "Submission Report";
export const unitsExpectedTitle = "Units Expected to Submit Report";
export const matsModule = "MATS Data Submission";
export const evaluateModule = "Evaluate";
export const submitModule = "Submit";
export const reviewAndsubmitModule = "Review & Submit";